// Lib
import React from 'react';
import EmojiPopupWrapper from '../../../emoji/popup/EmojiPopupWrapper';
import EmojiPopupContent from '../../../emoji/popup/EmojiPopupContent';
import { convertUnifiedCodeToEmojiString } from '../../../../../common/emoji/emojiUtil';

interface CalloutEmojiPopupProps {
    popupId: string;
    selectedEmojiId: string;
    updateAttributes: (attrs: Record<string, any>) => void;
}

interface CalloutEmojiPopupContentProps extends CalloutEmojiPopupProps {
    gridSize: number;
    closePopup: () => void;
}

const CalloutEmojiPopupContent: React.FC<CalloutEmojiPopupContentProps> = (props) => {
    const { selectedEmojiId, gridSize, closePopup, updateAttributes } = props;

    const onSelectEmoji = (emojiId: string) => {
        const icon = convertUnifiedCodeToEmojiString(emojiId);
        updateAttributes({ icon, iconCode: emojiId });
    };

    return (
        <EmojiPopupContent
            gridSize={gridSize}
            selectedEmojiIds={[selectedEmojiId]}
            onSelectEmoji={onSelectEmoji}
            closePopup={closePopup}
        />
    );
};

const CalloutEmojiPopup: React.FC<CalloutEmojiPopupProps> = ({ popupId, selectedEmojiId, updateAttributes }) => {
    return (
        <EmojiPopupWrapper className="CalloutEmojiPopup" popupId={popupId}>
            {(gridSize, closePopup) => (
                <CalloutEmojiPopupContent
                    gridSize={gridSize}
                    closePopup={closePopup}
                    selectedEmojiId={selectedEmojiId}
                    popupId={popupId}
                    updateAttributes={updateAttributes}
                />
            )}
        </EmojiPopupWrapper>
    );
};

export default CalloutEmojiPopup;
